import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientNutritionGoal, createdPatientNutritionGoal, nutritionGoal, weeklyNutritionGoals } from '__mocks__/mockData/patient-nutrition-goals';

const PatientNutritionGoalsApi = [
  rest.get(`${API_ROOT}patient-nutrition-goals`, (req, res, ctx) => {
    const dateRange = req.url.searchParams.get('dateRange');
    if (dateRange === '7') {
      return res(ctx.json(weeklyNutritionGoals));
    }
    return res(ctx.json(nutritionGoal));
  }),
  rest.delete(`${API_ROOT}patient-nutrition-goals/${patientNutritionGoal.data.nutrition_goal.id}`, (req, res, ctx) =>
    res(ctx.json({ id: patientNutritionGoal.data.nutrition_goal.id })),
  ),
  rest.post(`${API_ROOT}patient-nutrition-goals`, (req, res, ctx) => res(ctx.json(createdPatientNutritionGoal))),
];
export default PatientNutritionGoalsApi;
